//
// Instruction Set Architecture
//   as much as you can call it that :)
//

module.exports.NOP = 0;
module.exports.PUSH_VAL = 1;
module.exports.PUSH_DATA_INDEX = 2;
module.exports.PROC_BINARY = 3;

